import _ from "lodash";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  Image,
} from "@react-pdf/renderer";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Label,
  Input,
  Nav,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  InputGroupAddon,
  InputGroup,
  Modal,
  Form,
  Button,
} from "reactstrap";
import { MDBDataTable } from "mdbreact";
import classnames from "classnames";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import logo from "../../assets/images/logo-dark.png";
import firebase from "firebase/app";
import "firebase/database";

/***/
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { shipping_data_read, detail_error } from "../../store/actions";
import Lottie from "react-lottie";
/***/

class Delivery extends Component {
  constructor() {
    super();
    this.state = {
      all_data_snap_by_month: [],
      month_to_show: [],
      selected_month_to_show: [],
      activeTab: "1",
      data_by_lot_no: [],
      ready: false,
      data_to_show_in_table: [],
      commission_total: 0,
    };
  }

  toggle() {
    this.setState(
      (prevState) => ({
        ready: false,
      }),
      () => {
        setTimeout(() => {
          this.setState({ ready: true });
        }, 1);
      }
    );
  }
  table_titles(data_taken) {
    var titles_to_show = [];

    var titles = ["HBL", "Lot No", "Salesperson", "Commission"];

    titles.forEach((element, i) => {
      var percentage = 100 / 4;
      percentage = percentage + "%";
      titles_to_show.push(
        <Text
          key={i}
          style={{
            width: percentage, //"20%",
            borderRightColor: "#CFD8DC",
            borderRightWidth: 1,
          }}
        >
          {element}
        </Text>
      );
    });
    return (
      <View
        style={{
          flexDirection: "row",
          borderBottomColor: "#CFD8DC",
          backgroundColor: "#CFD8DC",
          borderBottomWidth: 1,
          alignItems: "center",
          // height: 24,
          paddingTop: 10,
          paddingBotttom: 10,
          textAlign: "center",
          fontStyle: "bold",
        }}
      >
        {titles_to_show}
      </View>
    );
  }

  line_items(data_taken) {
    var list_to_show = [];
    var percentage = 100 / 4;
    percentage = percentage + "%";

    data_taken.forEach((element, i) => {
      list_to_show.push(
        <View
          style={{
            flexDirection: "row",
            borderBottomColor: "#CFD8DC",
            borderBottomWidth: 1,
            alignItems: "center",
            height: 24,
            fontStyle: "bold",
          }}
          key={i}
        >
          <Text
            style={{
              width: percentage, //"20%",
              textAlign: "center",
              borderRightColor: "#CFD8DC",
              borderRightWidth: 1,
              paddingLeft: 8,
              fontSize: 8,
            }}
          >
            {element.HBL}
          </Text>
          <Text
            style={{
              width: percentage, //"20%",
              borderRightColor: "#CFD8DC",
              borderRightWidth: 1,
              textAlign: "center",
              paddingRight: 8,
              fontSize: 8,
            }}
          >
            {element.Lot_No}
          </Text>
          <Text
            style={{
              width: percentage, //"20%",
              textAlign: "center",
              borderRightColor: "#CFD8DC",
              borderRightWidth: 1,
              paddingRight: 8,
              fontSize: 8,
            }}
          >
            {element.salesperson}
          </Text>
          <Text
            style={{
              width: percentage, //"20%",
              borderRightColor: "#CFD8DC",
              borderRightWidth: 1,
              textAlign: "center",
              paddingRight: 8,
              fontSize: 8,
            }}
          >
            {element.commission}
          </Text>
        </View>
      );
    });

    return list_to_show;
  }
  show_report() {
    const { ready, data_to_show_in_table } = this.state;
    if (data_to_show_in_table.length > 0) {
      var data_taken = data_to_show_in_table;
      var title = "Zainco Salesperson Report";

      var table_titles = this.table_titles(data_taken);

      var line_items = this.line_items(data_taken);

      return (
        <Document>
          <Page
            size="A4"
            style={{
              fontFamily: "Helvetica",
              fontSize: 11,
              paddingTop: 30,
              paddingLeft: 60,
              paddingRight: 60,
              lineHeight: 1.5,
              flexDirection: "column",
            }}
          >
            <Image
              style={{
                width: 74,
                marginLeft: "auto",
                marginRight: "auto",
              }}
              src={logo}
            />

            <View
              style={{
                flexDirection: "row",
                marginTop: 24,
              }}
            >
              <Text
                style={{
                  color: "#263238",
                  fontSize: 15,
                  textAlign: "center",
                  textTransform: "uppercase",
                }}
              >
                {title}
              </Text>
            </View>

            <View
              style={{
                flexDirection: "row",
                marginTop: 24,
              }}
            >
              <Text
                style={{
                  color: "#263238",
                  fontSize: 12,
                  textAlign: "center",
                  textTransform: "uppercase",
                }}
              >
                Total Commission: {this.state.commission_total}
              </Text>
            </View>

            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                marginTop: 24,
                borderWidth: 1,
                borderColor: "#CFD8DC",
              }}
            >
              {table_titles}

              {line_items}
            </View>
          </Page>
        </Document>
      );
    } else {
      return (
        <Document>
          <Page
            size="A4"
            style={{
              fontFamily: "Helvetica",
              fontSize: 11,
              paddingTop: 30,
              paddingLeft: 60,
              paddingRight: 60,
              lineHeight: 1.5,
              flexDirection: "column",
            }}
          >
            <Image
              style={{
                width: 74,
                marginLeft: "auto",
                marginRight: "auto",
              }}
              src={logo}
            />
          </Page>
        </Document>
      );
    }
  }

  show_report_based_on_hbl() {
    const { shipping_data } = this.props;
    const { ready } = this.state;

    // var month_to_show = [];

    var users_to_show = [];
    var limited_access_users = _.map(
      this.props.limited_users_data,
      (val, uid) => {
        return { ...val, uid };
      }
    );

    var table_data = {};
    var MyDocument;
    if (this.state.data_to_show_in_table.length !== 0) {
      table_data = {
        columns: [
          {
            label: "HBL",
            field: "HBL",
            sort: "asc",
            width: 150,
          },
          {
            label: "Lot No",
            field: "Lot_No",
            sort: "asc",
            width: 270,
          },

          {
            label: "Salesperson",
            field: "salesperson",
            sort: "asc",
            width: 270,
          },

          {
            label: "Commission",
            field: "commission",
            sort: "asc",
            width: 270,
          },
        ],
        rows: this.state.data_to_show_in_table,
      };

      MyDocument = this.show_report();
    }
    limited_access_users.forEach((element) => {
      users_to_show.push(<option value={element.name}>{element.name}</option>);
    });

    return (
      <div>
        <Form encType="multipart/form-data">
          <div data-repeater-list="group-a">
            <Row data-repeater-item>
              <Col lg="6" className="form-group">
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    <Label className="input-group-text">LOT NO</Label>
                  </InputGroupAddon>
                  <Input
                    className="form-control"
                    onChange={(event) => {
                      var value = event.target.value;

                      var data = _.map(shipping_data, (val, uid) => {
                        return { ...val, uid };
                      });

                      var data_to_show_in_table = [];

                      data.forEach((element) => {
                        if (element.full_detail !== undefined) {
                          if (
                            element.full_detail.sales_commission !== undefined
                          ) {
                            if (
                              element.full_detail.sales_commission
                                .salesperson_name === value
                            ) {
                              data_to_show_in_table.push({
                                HBL: element.uid,
                                Lot_No: element.Lot_No,
                                salesperson:
                                  element.full_detail.sales_commission
                                    .salesperson_name,
                                commission: parseFloat(
                                  element.full_detail.sales_commission
                                    .commission
                                ).toFixed(2),
                                Date: element.Date,
                              });
                            }
                          }
                        }
                      });

                      if (data_to_show_in_table.length === 0) {
                        console.log("Nothing to show");
                      } else {
                        var all_data_snap_by_month = _.map(
                          data_to_show_in_table,
                          (val, uid) => {
                            var date_splitted = val.Date.split("/");

                            var data = {
                              label: moment(
                                `${date_splitted[1]}/${date_splitted[0]}/${date_splitted[2]}`
                              ).format("MMMM YYYY"),
                              data: { uid, ...val },
                            };

                            return data;
                          }
                        );

                        var seen_all_data_by_month = new Map();
                        //
                        all_data_snap_by_month = all_data_snap_by_month.filter(
                          (entry) => {
                            var previous;
                            if (
                              seen_all_data_by_month.hasOwnProperty(entry.label)
                            ) {
                              previous = seen_all_data_by_month[entry.label];
                              previous.data.push(entry.data);

                              return false;
                            }
                            if (!Array.isArray(entry.data)) {
                              entry.data = [entry.data];
                            }
                            seen_all_data_by_month[entry.label] = entry;

                            return true;
                          }
                        );

                        all_data_snap_by_month = _.fromPairs(
                          _.map(all_data_snap_by_month, (i) => {
                            return [i.label, i.data];
                          })
                        );

                        var raw_data_month = all_data_snap_by_month;
                        // console.log(all_data_snap_by_month);

                        all_data_snap_by_month = _.map(
                          all_data_snap_by_month,
                          (val, uid) => {
                            return { ...val, uid };
                          }
                        );

                        var month_to_show = [];
                        all_data_snap_by_month.forEach((element, i) => {
                          month_to_show.push(
                            <option value={i}>{element.uid}</option>
                          );
                        });

                        this.setState({
                          month_to_show,
                          all_data_snap_by_month: raw_data_month,
                        });
                      }
                    }}
                    type="select"
                  >
                    <option value="">Select Lot No.</option>
                    {users_to_show}
                  </Input>
                </InputGroup>
              </Col>
            </Row>
          </div>
        </Form>

        {this.state.month_to_show.length !== 0 ? (
          <Form encType="multipart/form-data">
            <div data-repeater-list="group-a">
              <Row data-repeater-item>
                <Col lg="6" className="form-group">
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      <Label className="input-group-text">Select Month</Label>
                    </InputGroupAddon>
                    <Input
                      className="form-control"
                      onChange={(event) => {
                        var value = event.target.value;

                        var data_to_show_in_table = [];

                        var monthsdata = this.state.all_data_snap_by_month; //all_data_snap_by_month[value];

                        monthsdata = _.map(monthsdata, (val, uid) => {
                          return { ...val };
                        });

                        var month_data = _.map(
                          monthsdata[value],
                          (val, uid) => {
                            return { ...val };
                          }
                        );

                        var commission_total = 0.0;
                        month_data.forEach((element) => {
                          data_to_show_in_table.push({
                            HBL: element.HBL,
                            Date: element.Date,
                            Lot_No: element.Lot_No,
                            salesperson: element.salesperson,
                            commission: element.commission,
                          });
                          commission_total =
                            commission_total + parseFloat(element.commission);
                        });

                        commission_total = commission_total.toFixed(2);
                        this.setState({
                          data_to_show_in_table,
                          commission_total,
                        });
                      }}
                      type="select"
                    >
                      <option value="">Select...</option>
                      {this.state.month_to_show}
                    </Input>
                  </InputGroup>
                </Col>
              </Row>
            </div>
          </Form>
        ) : null}

        {this.state.data_to_show_in_table.length !== 0 ? (
          <div>
            <div className="row">
              <div className="col-6">
                {ready && (
                  <PDFDownloadLink document={MyDocument} fileName="PDF">
                    {({ blob, url, loading, error }) =>
                      loading ? (
                        "Loading document..."
                      ) : (
                        <Button onClick={() => this.setState({ ready: false })}>
                          Download Report
                        </Button>
                      )
                    }
                  </PDFDownloadLink>
                )}
                {!ready && (
                  <Button
                    onClick={() => {
                      // this.setState({ data_to_show_in_table: });
                      this.toggle();
                    }}
                  >
                    Generate Report
                  </Button>
                )}
              </div>
              <div className="col-6">
                <p>Total Commission: {this.state.commission_total}</p>
              </div>
            </div>
            <div
              style={{
                paddingTop: 20,
                paddingLeft: 15,
                paddingRight: 15,
              }}
            >
              <MDBDataTable responsive striped bordered data={table_data} />
            </div>
          </div>
        ) : null}
      </div>
    );

    /* const { shipping_data } = this.props;

    var limited_access_users = _.map(
      this.props.limited_users_data,
      (val, uid) => {
        return { ...val, uid };
      }
    );
    console.log(limited_access_users);

    var data = shipping_data;

    var all_data_snap_by_month = _.map(data, (val, uid) => {
      // var formated_date = moment(val.Date, "dd/mm/yyyy").valueOf();
      // console.log(formated_date);

      var data = {
        // label: moment(formated_date), //.format("MMMM YYYY"),
        label: moment(val.Date).format("MMMM YYYY"),
        data: { uid, ...val },
      };

      return data;
    });

    var seen_all_data_by_month = new Map();
    //
    all_data_snap_by_month = all_data_snap_by_month.filter((entry) => {
      var previous;
      if (seen_all_data_by_month.hasOwnProperty(entry.label)) {
        previous = seen_all_data_by_month[entry.label];
        previous.data.push(entry.data);

        return false;
      }
      if (!Array.isArray(entry.data)) {
        entry.data = [entry.data];
      }
      seen_all_data_by_month[entry.label] = entry;

      return true;
    });

    all_data_snap_by_month = _.fromPairs(
      _.map(all_data_snap_by_month, (i) => {
        return [i.label, i.data];
      })
    );

    // console.log(all_data_snap_by_month);

    data = _.map(data, (val, uid) => {
      return { ...val, uid };
    });

    var data_to_show_in_table = [];

    data.forEach((element) => {
      if (element.full_detail !== undefined) {
        if (element.full_detail.sales_commission !== undefined) {
          data_to_show_in_table.push({
            HBL: element.uid,
            Lot_No: element.Lot_No,
            salesperson: element.full_detail.sales_commission.salesperson_name,
            commission: element.full_detail.sales_commission.commission,
          });
        }
      }
    });

    const table_data = {
      columns: [
        {
          label: "HBL",
          field: "HBL",
          sort: "asc",
          width: 150,
        },
        {
          label: "Lot No",
          field: "Lot_No",
          sort: "asc",
          width: 270,
        },

        {
          label: "Salesperson",
          field: "salesperson",
          sort: "asc",
          width: 270,
        },

        {
          label: "Commission",
          field: "commission",
          sort: "asc",
          width: 270,
        },
      ],
      rows: data_to_show_in_table,
    };

    const { ready } = this.state;

    const MyDocument = this.show_report();

    return (
      <div>
        <div>
          {ready && (
            <PDFDownloadLink document={MyDocument} fileName="PDF">
              {({ blob, url, loading, error }) =>
                loading ? (
                  "Loading document..."
                ) : (
                  <Button onClick={() => this.setState({ ready: false })}>
                    Download Report
                  </Button>
                )
              }
            </PDFDownloadLink>
          )}
          {!ready && (
            <Button
              onClick={() => {
                this.setState({ data_to_show_in_table });
                this.toggle();
              }}
            >
              Generate Report
            </Button>
          )}
        </div>
        <div
          style={{
            paddingTop: 20,
            paddingLeft: 15,
            paddingRight: 15,
          }}
        >
          <MDBDataTable responsive striped bordered data={table_data} />
        </div>
      </div>
    );


    */
  }

  processing() {
    const { data } = this.props;

    var snapshot = data;
    var all_data_lot_no = _.map(snapshot, (val, uid) => {
      var data = {
        label: val.Lot_No,

        data: { uid, ...val },
      };

      return data;
    });

    var seen_all_data_lot_no = new Map();
    //
    all_data_lot_no = all_data_lot_no.filter((entry) => {
      var previous;
      if (seen_all_data_lot_no.hasOwnProperty(entry.label)) {
        previous = seen_all_data_lot_no[entry.label];
        previous.data.push(entry.data);

        return false;
      }
      if (!Array.isArray(entry.data)) {
        entry.data = [entry.data];
      }
      seen_all_data_lot_no[entry.label] = entry;

      return true;
    });

    all_data_lot_no = _.fromPairs(
      _.map(all_data_lot_no, (i) => {
        return [i.label, i.data];
      })
    );

    return all_data_lot_no;
  }

  show_table_filtered_by_lot_no() {
    var data = this.state.data_by_lot_no;
    var data_to_show_in_table = [];
    var show_data = [];
    data.forEach((element) => {
      if (element.full_detail !== undefined) {
        show_data.push(element);
      }
    });

    show_data.forEach((element) => {
      const {
        cargo_details,
        consignee_details,
        other_charges,
        payments_details,
        shipper_details,
      } = element.full_detail;

      data_to_show_in_table.push({
        HBL: element.uid,
        Lot_No: element.Lot_No,
        Consignee: element.Consignee,
        Shipper: element.Shipper,
        Total_outstanding_balance: 0,
      });
    });

    const table_data = {
      columns: [
        {
          label: "HBL",
          field: "HBL",
          sort: "asc",
          width: 150,
        },
        {
          label: "Lot No",
          field: "Lot_No",
          sort: "asc",
          width: 270,
        },
        {
          label: "Consignee",
          field: "Consignee",
          sort: "asc",
          width: 200,
        },
        {
          label: "Shipper",
          field: "Shipper",
          sort: "asc",
          width: 100,
        },

        {
          label: "Outstanding Balance",
          field: "Total_outstanding_balance",
          sort: "asc",
          width: 100,
        },
      ],
      rows: data_to_show_in_table,
    };

    const { ready } = this.state;

    const MyDocument = this.show_report();
    return (
      <div>
        <div>
          {ready && (
            <PDFDownloadLink document={MyDocument} fileName="PDF">
              {({ blob, url, loading, error }) =>
                loading ? (
                  "Loading document..."
                ) : (
                  <Button onClick={() => this.setState({ ready: false })}>
                    Download Report
                  </Button>
                )
              }
            </PDFDownloadLink>
          )}
          {!ready && (
            <Button
              onClick={() => {
                this.setState({ data_to_show_in_table });
                this.toggle();
              }}
            >
              Generate Report
            </Button>
          )}
        </div>
        <div
          style={{
            paddingTop: 20,
            paddingLeft: 15,
            paddingRight: 15,
          }}
        >
          <MDBDataTable responsive striped bordered data={table_data} />
        </div>
      </div>
    );
  }
  show_report_based_on_lot_no() {
    var data_filtered = this.processing();

    var options_to_show = [];
    if (Object.keys(data_filtered).length > 0) {
      var data = _.map(data_filtered, (val, uid_lot) => {
        return { data: { ...val }, uid_lot };
      });

      var data_with_details = [];
      data.forEach((element) => {
        var first_element = element.data[0];
        if (first_element.full_detail !== undefined) {
          data_with_details.push(element);
        }
      });

      data_with_details.forEach((element, i) => {
        options_to_show.push(<option value={i}>{element.uid_lot}</option>);
      });
    }

    return (
      <div>
        <Form encType="multipart/form-data">
          <div data-repeater-list="group-a">
            <Row data-repeater-item>
              <Col lg="6" className="form-group">
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    <Label className="input-group-text">LOT NO</Label>
                  </InputGroupAddon>
                  <Input
                    className="form-control"
                    onChange={(event) => {
                      var value = event.target.value;

                      if (value !== "") {
                        if (data_with_details[value].data) {
                          var converted_data = _.map(
                            data_with_details[value].data,
                            (val) => {
                              return { ...val };
                            }
                          );

                          this.setState({
                            data_by_lot_no: converted_data,
                          });
                        }
                      }
                    }}
                    type="select"
                  >
                    <option value="">Select Lot No.</option>
                    {options_to_show}
                  </Input>
                </InputGroup>
                <p>
                  <span style={{ fontWeight: "bold" }}>NOTE:</span>{" "}
                  <span style={{ color: "red" }}>
                    This options is only for shipments created or updated using
                    this software.
                  </span>
                </p>
              </Col>
            </Row>
          </div>
        </Form>

        {this.state.data_by_lot_no.length > 0 ? (
          <div>{this.show_table_filtered_by_lot_no()}</div>
        ) : null}
      </div>
    );
  }

  render() {
    const { loading } = this.props;
    if (loading === true) {
      const loadingjson = {
        loop: true,
        autoplay: true,
        animationData: require("./JSON/loading.json"),

        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };

      return (
        <div className="page-content">
          <Container fluid>
            <Row className="justify-content-center mt-lg-5">
              <div className="text-center">
                <Row className="justify-content-center">
                  <div className="text-center">
                    <Lottie options={loadingjson} height={300} width={300} />
                  </div>
                </Row>
              </div>
            </Row>
          </Container>
        </div>
      );
    }
    return (
      <div>
        <TabContent activeTab={this.state.activeTab} className="mt-4">
          <TabPane tabId="1" id="buy-tab">
            {this.show_report_based_on_hbl()}
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  const { shipping_data, error, loading, limited_users_data } = state.Database;

  return {
    shipping_data,
    error,
    loading,
    limited_users_data,
  };
};

export default withRouter(
  connect(mapStatetoProps, {
    shipping_data_read,
    detail_error,
  })(withNamespaces()(Delivery))
);
